class Artigo {
    constructor({ idUsuario, idArtigoWp, url, html, slug, titulo, isPublicado,
        idUsuarioWordpress, otimizado, listaPalavraChave, dataPublicacao, urlAcessoPost }) {
        this.idUsuario = idUsuario
        this.idEmpresa = null
        this.idArtigoWp = idArtigoWp
        this.url = url
        this.html = html
        this.slug = slug
        this.titulo = titulo
        this.isPublicado = isPublicado
        this.idUsuarioWordpress = idUsuarioWordpress
        this.otimizado = otimizado
        this.listaPalavraChave = listaPalavraChave
        this.dataPublicacao = dataPublicacao
        this.urlAcessoPost = urlAcessoPost
        this.imagemDestaque = ""
        this.autor = ""
        this.metaDescricao = ""
        this.tituloSEO = ""
        this.robots = ""
    }
}

export default Artigo